module.exports = __webpack_public_path__ + "img/success.b81e295c.png";